import { TrustlyBanksData } from '../../constants'
import { useState } from 'react'
import { isValidArray, tr } from 'mmfintech-commons'
import PlusIcon from '@assets/icons/plus.svg?react'

import { TrustlyBankIcon } from './TrustlyBankIcon'

type TrustlyBanksProps = {
  alpha2CountryCode?: string
  initialCount?: number
}

export const TrustlyBanks = (props: TrustlyBanksProps) => {
  const { alpha2CountryCode, initialCount = 6 } = props

  const [extendedDisplay, setExtendedDisplay] = useState<boolean>(false)

  const banks = alpha2CountryCode ? TrustlyBanksData[alpha2CountryCode] : null
  const bankCodes = banks ? Object.keys(banks) : []
  const bankCodesFiltered = bankCodes?.slice(0, initialCount)

  return isValidArray(bankCodesFiltered) ? (
    <div className='banks'>
      {(extendedDisplay ? bankCodes : bankCodesFiltered).map(bankCode => (
        <TrustlyBankIcon
          key={bankCode}
          alpha2CountryCode={alpha2CountryCode}
          bankCode={bankCode}
          bankName={banks[bankCode]}
        />
      ))}
      {bankCodesFiltered.length < bankCodes.length && !extendedDisplay && (
        <div
          className='show-more'
          onClick={() => setExtendedDisplay(true)}
          title={
            extendedDisplay
              ? tr('CHECKOUT.TRUSTLY.SHOW_LESS', 'Show less')
              : tr('CHECKOUT.TRUSTLY.SHOW_MORE', 'Show more')
          }
        >
          <PlusIcon />
        </div>
      )}
    </div>
  ) : null
}
